import pdfMake from "pdfmake/build/pdfmake";
import getDocDefinition from "./docDefination";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


function printDoc(printParams, gridApi, columnApi, heading) {
  console.log("Exporting to PDF...");
  const docDefinition = getDocDefinition(printParams, gridApi, columnApi, heading);
  pdfMake.createPdf(docDefinition).download();
}

export default printDoc;
